<template>
  <v-app @scroll="handleScroll">
    <v-app-bar app light color="green lighten-5" class="header"
      v-if="$route.meta.requiresAdmin || $route.meta.requiresAuth">
      <v-app-bar-nav-icon v-if="authenticated" @click="drawer = !drawer"></v-app-bar-nav-icon>

      <span v-if="$vuetify.breakpoint.mdAndUp">
        {{ $route.meta.description }}
      </span>

      <v-spacer></v-spacer>

      <div v-if="authenticated">
        <!-- <ComplaintNotifications /> -->
        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-on="on"
              class="mr-3"
              v-bind="attrs"
              to="/notifications"
            >
              <Notifications />
            </v-btn>
          </template>
          <span>Notifications</span>
        </v-tooltip> -->

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-on="on" class="mr-2" v-bind="attrs" @click="logoutUser">
              <v-icon>mdi-lock-outline</v-icon>
            </v-btn>
          </template>
          <span>Logout</span>
        </v-tooltip>

        <Avatar :person="user" :class="'alt'" />
      </div>
      <span v-else>
        <v-btn small class="mr-1" to="/" text>
          <span class="mr-1">Home</span>
          <v-icon>mdi-home-outline</v-icon>
        </v-btn>

        <v-btn small text to="/login">
          <span class="mr-1">Login</span>
          <v-icon>mdi-login-variant</v-icon>
        </v-btn>
      </span>
    </v-app-bar>

    <v-navigation-drawer v-if="
      authenticated && ($route.meta.requiresAdmin || $route.meta.requiresAuth)
    " v-model="drawer" floating app dark>
      <template v-slot:prepend>
        <div class="jmesr-header pa-3">
          <div class="d-flex align-center justify-center">
            <v-img contain position="center" class="shrink"
              src="https://user-images.githubusercontent.com/46636890/146361318-2781f6a0-5fb0-48ef-bedc-73bd7edf2e2a.png"
              transition="scale-transition" :height="$vuetify.breakpoint.smAndUp ? '60px' : '45px'" />
          </div>
        </div>
      </template>

      <v-list dense nav>
        <v-list-item-group active-class="green--text text--accent-4">
          <!-- <v-list-item class="mb-1" to="/dashboard">
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item> -->

          <AuthorMenu v-if="authenticated && author" />

          <ReviewerMenu v-if="authenticated && reviewer" />

          <EditorMenu v-if="authenticated && editor" />

          <PublisherMenu v-if="authenticated && publisher" />

          <AdministrationMenu v-if="authenticated && administrator" />

          <UserAccountMenu v-if="authenticated" />
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-main id="router-view">
      <router-view :key="$route.fullPath"></router-view>
    </v-main>

    <v-footer app>
      <div class="footer">
        <span v-if="$vuetify.breakpoint.lg">
          © {{ new Date().getFullYear() }}
          <span class="hidden-xs">
            International Center for Energy and Sustainability Research
          </span>
          <span v-if="authenticated">
            |
            <strong class="ml-1">
              {{ user.title }} {{ user.firstName }} {{ user.lastName }}
            </strong>
          </span>
        </span>

        <span class="contact">
          <router-link v-if="!authenticated" to="/login" class="mr-2">
            Login
          </router-link>
          <router-link v-else class="mr-2" to="/dashboard">
            Dashboard
          </router-link>
          <a href="https://jmesr.iceesr.org.ng">Journal homepage</a>
        </span>
      </div>
    </v-footer>

    <Alert />
    <Snackbar />
    <Requesting />

    <v-fab-transition>
      <v-btn v-if="showScrollTopButton" @click="scrollToTop" fixed bottom right fab dark class="mb-6"
        color="green accent-4">
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-app>
</template>

<script>
import Alert from "./components/Utils/Alert";
import Avatar from "./components/Utils/Avatar";
import Snackbar from "./components/Utils/SnackBar";
import Requesting from "./components/Utils/Requesting";

import AdministrationMenu from "./components/Utils/Drawer/Administration";
import AuthorMenu from "./components/Utils/Drawer/Author";
import ReviewerMenu from "./components/Utils/Drawer/Reviewer";
import EditorMenu from "./components/Utils/Drawer/Editor";
import PublisherMenu from "./components/Utils/Drawer/Publisher";
import UserAccountMenu from "./components/Utils/Drawer/UserAccount.vue";

export default {
  name: "App",

  components: {
    Alert,
    Avatar,
    Snackbar,
    Requesting,
    AuthorMenu,
    ReviewerMenu,
    EditorMenu,
    PublisherMenu,
    AdministrationMenu,
    UserAccountMenu,
  },

  data: () => ({
    user: {
      id: null,
      type: null,
      firstName: null,
      lastName: null,
    },
    authenticated: false,
    author: false,
    reviewer: false,
    administrator: false,
    editor: false,
    publisher: false,

    drawer: true,

    showScrollTopButton: false,
    showScrollBottomButton: false,
  }),

  methods: {
    async logoutUser() {
      const authenticated = !!localStorage.getItem("jmesrAuth");
      if (authenticated) {
        await this.$axios.get("/logout");
      }
      localStorage.removeItem("jmesrAuth");
      localStorage.removeItem("jmesrUser");

      if (this.$router.currentRoute.name != "login") {
        this.$router.push({ name: "login" });
      }

      this.refreshAuth();
    },
    refreshAuth() {
      const authenticated = !!localStorage.getItem("jmesrAuth");
      this.authenticated = authenticated;

      if (authenticated) {
        this.user = JSON.parse(localStorage.getItem("jmesrUser"));
        this.administrator =
          this.user.roles.includes("ADMIN") ||
          this.user.roles.includes("PUBLISHER");
        this.author = this.user.roles.includes("AUTHOR");
        this.reviewer = this.user.roles.includes("REVIEWER");
        this.editor = this.user.roles.includes("EDITOR");
        this.publisher = this.user.roles.includes("PUBLISHER");
      } else {
        localStorage.removeItem("jmesrAuth");
        localStorage.removeItem("jmesrUser");
        this.user = {
          role: 0,
          type: null,
          active: false,
          verified: false,
          name: "",
        };
      }
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        (document.documentElement || document.body.parentNode || document.body)
          .scrollTop;

      this.showScrollTopButton = scrollTop > 300;
      this.showScrollBottomButton = scrollTop < 300;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },

  mounted() {
    this.refreshAuth();

    this.$bus.$on("login", this.refreshAuth);
    this.$bus.$on("logout", this.logoutUser);
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>


<style lang="scss">
html,
body,
.v-application {
  line-height: 1.5;
  scroll-behavior: smooth;
  scroll-padding-top: 2em;

  background: #eee;
  // overflow-x: hidden;

  // font-family: "Noto Sans", sans-serif !important;
  // font-family: 'Noto Serif', serif;

  font-family: "Work Sans", sans-serif;

  .option {
    p {
      margin-bottom: 0 !important;
    }
  }
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  // border-radius: 2px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

// .theme--light.v-application {
//   background: #f2f8f3 !important;
// }

.v-card>*:first-child:not(.v-btn):not(.v-chip):not(.v-avatar),
.v-card>.v-card__progress+*:not(.v-btn):not(.v-chip):not(.v-avatar) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.jmesr-header {
  background-color: #2fa629;
  // background-image: url("https://cdn.pixabay.com/photo/2014/12/15/16/57/tree-569275_960_720.jpg");
}

.v-toolbar__content,
.v-toolbar__extension {
  align-items: center;
  display: flex;
  position: relative;
  z-index: 0;
  height: 100% !important;
}

.header {
  background: transparent;

  h2 {
    color: #ffffff;
    color: #0a4e23;
  }

  .logo-wrapper {
    background: #ffffff;
    padding: 0.6em 0.45em 0.3em;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  }
}

.basil {
  background-color: #fffbe6 !important;
}

.basil--text {
  color: #356859 !important;
}

.message {
  white-space: pre-wrap;
}

.footer {
  width: 100%;
  display: flex;
  font-size: 0.75em;

  .contact {
    margin-left: auto;

    a {
      text-decoration: none;
      color: #2a8414;
    }
  }
}

.no-word-break {
  hyphens: none;
}

.help-tip {
  position: absolute;
  top: 18px;
  right: 18px;
  text-align: center;
  background-color: #bcdbea;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-size: 14px;
  line-height: 26px;
  cursor: default;
}

.help-tip:before {
  content: "?";
  font-weight: bold;
  color: #fff;
}

.help-tip:hover p {
  display: block;
  transform-origin: 100% 0%;

  -webkit-animation: fadeIn 0.3s ease-in-out;
  animation: fadeIn 0.3s ease-in-out;
}

.help-tip p {
  /* The tooltip */
  display: none;
  text-align: left;
  background-color: #1e2021;
  padding: 20px;
  width: 300px;
  position: absolute;
  border-radius: 3px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  right: -4px;
  color: #fff;
  font-size: 13px;
  line-height: 1.4;
}

.help-tip p:before {
  /* The pointer of the tooltip */
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-bottom-color: #1e2021;
  right: 10px;
  top: -12px;
}

.help-tip p:after {
  /* Prevents the tooltip from being hidden */
  width: 100%;
  height: 40px;
  content: "";
  position: absolute;
  top: -40px;
  left: 0;
}

/* CSS animation */

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
    transform: scale(0.6);
  }

  100% {
    opacity: 100%;
    transform: scale(1);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 100%;
  }
}

.fade-enter-active {
  transition: all 0.5s ease;
}

// .fade-leave-active {
//   transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
// }

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
  transform: translateY(10px);
}

.communication-body {
  p {
    margin: 0 !important;
    margin-bottom: 0 !important;
  }
}
</style>
